import { render, staticRenderFns } from "./MyGiftCards.vue?vue&type=template&id=5871e525&"
import script from "./MyGiftCards.vue?vue&type=script&lang=js&"
export * from "./MyGiftCards.vue?vue&type=script&lang=js&"
import style0 from "./MyGiftCards.vue?vue&type=style&index=0&id=5871e525&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports